import { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import WorkGrid from "@/components/base/WorkGrid";
import EmptyState from "@/components/base/EmptyState";
import { getWorkById } from "@/utils/film";
import { useFavorites } from "@/hooks/useFavorites";

export default function Favorites() {
  const { ids, clear, count } = useFavorites();

  useEffect(() => {
    document.title = "我的收藏 - 白虎影视平台";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute("content", "查看你在白虎影视平台收藏的电影与电视剧作品，收藏基于浏览器本地存储，刷新后仍然保留。");
    }
  }, []);

  const works = useMemo(
    () => ids.map((id) => getWorkById(id)).filter((work) => work !== undefined),
    [ids]
  );

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6 md:py-12">
      <nav className="flex items-center gap-1.5 text-sm text-foreground-500" aria-label="面包屑">
        <Link to="/" className="transition-colors hover:text-accent-600">
          首页
        </Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-800">我的收藏</span>
      </nav>

      <header className="mt-5 flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            我的收藏
          </h1>
          <p className="mt-2 text-sm text-foreground-600">
            已收藏 <strong className="text-accent-600">{count}</strong> 部作品（收藏基于浏览器本地存储，刷新后仍然保留）
          </p>
        </div>
        {count > 0 ? (
          <button
            type="button"
            onClick={clear}
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
          >
            <i className="ri-delete-bin-line"></i>
            清空收藏
          </button>
        ) : null}
      </header>

      <div className="mt-8">
        {works.length === 0 ? (
          <EmptyState
            icon="ri-bookmark-line"
            title="还没有收藏任何作品"
            description="在影视详情页点击“收藏”按钮，就能把喜欢的作品加入这里，方便下次快速找到。"
            actionLabel="去发现好作品"
            actionHref="/movies"
          />
        ) : (
          <WorkGrid works={works} />
        )}
      </div>
    </div>
  );
}